import { useExportModalController } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/ExportModal/useExportModalController';
import { Alert } from '@dealstack/frontend/shared/components/Alert/Alert';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button, Text, rem } from '@mantine/core';
import { memo } from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';

interface Props {
	opened: boolean;
	onClose: () => void;
}

const ExportModal = ({ opened, onClose }: Props) => {
	const tMipManage = useTranslationMipManage();
	const { navigateToExportPage } = useExportModalController();
	return (
		<ReactModal
			contentLabel="download-all-contracts-modal"
			isOpen={opened}
			style={{
				content: {
					position: 'absolute',
					maxWidth: rem(480),
					top: '50%',
					left: '50%',
					right: 'auto',
					bottom: 'auto',
					transform: 'translate(-50%, -50%)',
					width: '100%',
				},
			}}
		>
			<Alert state="info" size="m">
				<Text size="B5Bold" style={{ marginBottom: '0.25rem' }}>
					{tMipManage('exports_modal.title')}
				</Text>
				<Text size="B5Medium">{tMipManage('exports_modal.body')}</Text>
				<AlertButtonWrapper>
					<Button onClick={navigateToExportPage} variant="secondary">
						{tMipManage('exports_modal.buttons.go_to_downloads')}
					</Button>
					<Button
						onClick={onClose}
						variant="ghost"
						style={{ backgroundColor: 'transparent' }}
					>
						{tMipManage('exports_modal.buttons.close')}
					</Button>
				</AlertButtonWrapper>
			</Alert>
		</ReactModal>
	);
};
const AlertButtonWrapper = styled.div`
	display: flex;
	gap: 0.5rem;
	margin-top: 1rem;
`;
const _ExportModalExport = memo(ExportModal);

export { _ExportModalExport as ExportModal };
